import styled, { css, keyframes } from 'styled-components';
import { defaultTheme } from '@styles/theme.styled';
import Image from '@components/image';
import Grid from '@components/grid';
import { generateScales } from '@helpers/generate-media-queries';

export const SecurityGrid = styled(Grid)`
  ${({ theme }) => css`
    column-gap: 5rem;
    row-gap: 3rem;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      row-gap: 3rem;
      column-gap: 6rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      row-gap: 4rem;
      column-gap: 4rem;
    }
  `}
`;

export const Padder = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.light}66;
    padding: 5rem 3rem;
    border-radius: ${theme.borderRadius.large};
    ${generateScales('row-gap', '1.5rem', '3rem', theme)}
    overflow: hidden;
  `}
`;

interface ContainerProps {
  backgroundColor: keyof typeof defaultTheme.backgroundColors;
}

export const Container = styled.div<ContainerProps>`
  ${({ backgroundColor = 'white', theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;
    width: 100%;
    max-width: 56rem;
    margin: 0 auto;
    text-align: center;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      text-align: left;
    }

    ${(backgroundColor === 'dark' || backgroundColor === 'primary') &&
    css`
      color: white;
    `};
  `}
`;

interface SecurtiyImageProps {
  width?: number;
  height?: number;
}

export const SecurtiyImage = styled(Image)<SecurtiyImageProps>`
  ${({ theme, width, height }) => css`
    max-height: 6rem;
    max-width: 12rem;
    align-self: center;
    margin: 0;
    aspect-ratio: ${width} / ${height};

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      max-height: 4.5rem;
      max-width: 9rem;
    }
  `}
`;

interface TickerProps {
  itemCount?: number;
}

const tickerScroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const Ticker = styled.div<TickerProps>`
  ${({ theme, itemCount = 1 }) => css`
    display: flex;
    flex-direction: row;
    ${generateScales('column-gap', '2.5rem', '7.5rem', theme)}
    ${generateScales('height', '2.5rem', '7.5rem', theme)}
    width: fit-content;
    margin: 0 auto;
    text-align: center;
    animation: ${tickerScroll} ${itemCount * 5}s linear infinite;

    &:hover {
      animation-play-state: paused;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      text-align: left;
    }

    ${SecurtiyImage} {
      max-height: 16rem;
      max-width: 10rem;
      height: 100%;
    }
  `}
`;
